import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/_authenticated/membros/perfil")({
  head: () => ({ meta: [{ title: "Perfil — Projeto 101" }, { name: "robots", content: "noindex, nofollow" }] }),
  component: ProfilePage,
});

function ProfilePage() {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState<string | null>(null);
  const [ents, setEnts] = useState<any[]>([]);

  useEffect(() => {
    (async () => {
      const { data: userRes } = await supabase.auth.getUser();
      if (!userRes.user) return;
      setEmail(userRes.user.email ?? "");
      const { data } = await supabase.from("profiles").select("*").eq("id", userRes.user.id).maybeSingle();
      if (data) setFullName(data.full_name ?? "");
      const { data: e } = await supabase
        .from("entitlements")
        .select("status, granted_at, product:products(name, slug)")
        .eq("user_id", userRes.user.id);
      setEnts(e ?? []);
    })();
  }, []);

  async function save() {
    const { data: userRes } = await supabase.auth.getUser();
    if (!userRes.user) return;
    await supabase.from("profiles").upsert({ id: userRes.user.id, full_name: fullName, email });
    setMsg("Perfil atualizado.");
    setTimeout(() => setMsg(null), 2000);
  }

  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <h1 className="font-display text-3xl font-extrabold">Perfil</h1>

      <div className="rounded-2xl border border-black/5 bg-white p-6">
        <h2 className="font-display text-lg font-extrabold">Dados</h2>
        <div className="mt-4 space-y-3">
          <label className="block text-sm">
            <span className="mb-1 block text-xs font-semibold uppercase tracking-wide text-[var(--gray-ink)]">Nome</span>
            <input value={fullName} onChange={(e) => setFullName(e.target.value)} className="w-full rounded-md border border-black/10 bg-white px-3 py-2 outline-none focus:border-[var(--green)]" />
          </label>
          <label className="block text-sm">
            <span className="mb-1 block text-xs font-semibold uppercase tracking-wide text-[var(--gray-ink)]">E-mail</span>
            <input value={email} readOnly className="w-full rounded-md border border-black/10 bg-[var(--gray-soft)] px-3 py-2 text-[var(--gray-ink)]" />
          </label>
          <button onClick={save} className="rounded-md bg-[var(--navy)] px-4 py-2 text-sm font-semibold text-white">Salvar</button>
          {msg && <p className="text-sm text-emerald-700">{msg}</p>}
        </div>
      </div>

      <div className="rounded-2xl border border-black/5 bg-white p-6">
        <h2 className="font-display text-lg font-extrabold">Meus acessos</h2>
        {ents.length === 0 ? (
          <p className="mt-2 text-sm text-[var(--gray-ink)]">Nenhum acesso registrado.</p>
        ) : (
          <ul className="mt-3 space-y-2 text-sm">
            {ents.map((e, i) => (
              <li key={i} className="flex items-center justify-between border-b border-black/5 pb-2 last:border-0">
                <span>{e.product?.name}</span>
                <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${e.status === "active" ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`}>
                  {e.status}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
